import React from 'react';
import { ReactComponent as LoadingSpinner } from './icons/loading-spinner.svg';

export default () => <LoadingSpinner />;
